
import { Routes, BrowserRouter, Route } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
// Components
import Header from 'components/commonComponents/Header';
import Footer from 'components/commonComponents/Footer';
import Contact from 'components/pages/Contact';
import About from 'components/pages/About';
import HomePage from 'components/pages/HomePage';
import Portfolio from 'components/pages/Portfolio';



const AppRouter = () => {
  return (
    <div>
      <BrowserRouter >
        <div>
          <Header />
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="*" element={<HomePage />} />

              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/portfolio" element={<Portfolio />} />

            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
  );
};
export default AppRouter;

